module.exports = "/assets/e77ff9bc7313c182cdfe10ec7020c976.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/IW.png
// module id = 2614
// module chunks = 0